document.addEventListener('DOMContentLoaded', function () {
    console.log("DOM fully loaded and parsed"); // LOG 1: Sprawdzenie startu DOMContentLoaded

    // --- Selektory ---
    const hamburgerButton = document.querySelector('.hamburger-toggle');
    const mainMenu = document.getElementById('main-menu-list');
    const closeMenuButton = mainMenu ? mainMenu.querySelector('.close-menu-button') : null;
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    const body = document.body;

    // --- Funkcje Pomocnicze ---

    // Funkcja do przełączania menu mobilnego
    function toggleMobileMenu() {
        if (!mainMenu || !hamburgerButton) {
            console.error("toggleMobileMenu: Main menu or hamburger button not found!");
            return;
        }
        console.log("Toggling mobile menu..."); // LOG: Wywołanie funkcji toggle
        const isExpanded = mainMenu.classList.contains('is-active');
        mainMenu.classList.toggle('is-active');
        hamburgerButton.setAttribute('aria-expanded', String(!isExpanded));
        body.style.overflow = mainMenu.classList.contains('is-active') ? 'hidden' : '';
        console.log("Menu active state:", mainMenu.classList.contains('is-active')); // LOG: Stan menu po przełączeniu
    }

    // Funkcja do zamykania wszystkich otwartych submenu (desktop)
    function closeAllSubmenus(exceptThisToggle = null) {
        // console.log("Attempting to close all submenus", exceptThisToggle ? "except one." : ""); // Opcjonalny log
        document.querySelectorAll('.submenu.submenu-active').forEach(submenu => {
            const parentToggle = submenu.previousElementSibling;
            if (!exceptThisToggle || parentToggle !== exceptThisToggle) {
                // console.log("Closing submenu for toggle:", parentToggle); // Opcjonalny log
                submenu.classList.remove('submenu-active');
                if (parentToggle && parentToggle.classList.contains('dropdown-toggle')) {
                    parentToggle.setAttribute('aria-expanded', 'false');
                }
            }
        });
    }

    // --- Inicjalizacja Event Listenerów ---

    // Obsługa kliknięcia hamburgera
    if (hamburgerButton && mainMenu) {
        console.log("Adding listener for hamburger button");
        hamburgerButton.addEventListener('click', function(event) {
            console.log("Hamburger button clicked"); // LOG: Kliknięcie hamburgera
            event.stopPropagation(); // Zapobiega bąbelkowaniu do document
            toggleMobileMenu();
        });
    } else {
        console.error("Hamburger button or Main menu not found! Cannot add listener.");
    }

    // Obsługa kliknięcia przycisku zamknięcia (X) w menu
    if (closeMenuButton) {
        console.log("Adding listener for close menu button");
        closeMenuButton.addEventListener('click', function(event) {
            console.log("Close menu button clicked"); // LOG: Kliknięcie przycisku X
            event.stopPropagation(); // Zapobiega bąbelkowaniu do document
            toggleMobileMenu();
        });
    } else {
        console.warn("Close menu button not found inside main menu.");
    }

    // Obsługa kliknięcia przełączników dropdown
    if (dropdownToggles.length > 0) {
        console.log(`Adding listeners for ${dropdownToggles.length} dropdown toggles`);
        dropdownToggles.forEach(toggle => {
            toggle.addEventListener('click', function (e) {
                const isMobileView = hamburgerButton && window.getComputedStyle(hamburgerButton).display === 'block';
                console.log("Dropdown toggle clicked. isMobileView:", isMobileView); // LOG 2: Sprawdzenie isMobileView w toggle

                if (isMobileView) {
                    console.log("Mobile view detected in toggle click, stopping submenu logic."); // LOG 3: Info o zatrzymaniu dla mobile
                    e.preventDefault(); // Zapobiega domyślnej akcji (np. skok do #)
                    // W widoku mobilnym kliknięcie na toggle często nic nie robi lub rozwija podmenu inaczej
                    // Jeśli ma rozwijać podmenu w mobile, logika musi być tutaj
                    return; // PRZERYWA WYKONANIE FUNKCJI W WIDOKU MOBILNYM
                }

                // Logika desktopowa (wykonuje się tylko gdy NIE jest isMobileView):
                console.log("Desktop view detected in toggle click, proceeding...");
                e.preventDefault(); // Zapobiega domyślnej akcji (np. skok do #)
                e.stopPropagation(); // Zatrzymuje propagację, aby document click nie zamknął od razu
                const submenu = this.nextElementSibling;
                if (submenu && submenu.classList.contains('submenu')) {
                    const isCurrentlyExpanded = submenu.classList.contains('submenu-active');
                    console.log("Submenu found. Currently expanded:", isCurrentlyExpanded);
                    closeAllSubmenus(this); // Zamknij inne submenus
                    submenu.classList.toggle('submenu-active'); // Otwórz/zamknij TO submenu
                    this.setAttribute('aria-expanded', String(!isCurrentlyExpanded));
                    console.log("Toggled submenu. Now active:", submenu.classList.contains('submenu-active'));
                } else {
                    console.warn("Submenu not found as next sibling for toggle:", this);
                }
            });
        });
    } else {
        console.warn("No dropdown toggles found.");
    }


    // NOWY LISTENER: Zamykanie menu mobilnego po kliknięciu linku
    if (mainMenu) {
        console.log("Adding listener for clicks inside main menu (for mobile link closing)");
        mainMenu.addEventListener('click', function(e) {
            // Działa tylko, gdy menu jest widoczne i aktywne w widoku mobilnym
            const isMobileView = hamburgerButton && window.getComputedStyle(hamburgerButton).display === 'block';
            const isMenuActive = mainMenu.classList.contains('is-active');
            // console.log(`Click inside main menu. isMobileView: ${isMobileView}, isMenuActive: ${isMenuActive}`); // Opcjonalny log

            if (isMobileView && isMenuActive) {
                const clickedLink = e.target.closest('a'); // Szuka klikniętego linku lub jego rodzica będącego linkiem

                if (clickedLink) {
                    // Sprawdź, czy to nie jest przycisk zamknięcia (ma swój własny listener)
                    // ani dropdown-toggle (w mobile nie powinien zamykać menu, chyba że to zamierzony efekt)
                    if (!clickedLink.classList.contains('close-menu-button') /* && !clickedLink.classList.contains('dropdown-toggle') */) {
                        // Usuń komentarz powyżej jeśli kliknięcie w toggle na mobile nie ma zamykać menu
                        console.log("Link clicked inside active mobile menu. Closing menu.", clickedLink); // LOG: Zamykanie menu po kliknięciu linku w mobile
                        toggleMobileMenu();
                        // UWAGA: Celowo NIE ma e.preventDefault() ani e.stopPropagation()
                        // Chcemy, aby link zadziałał normalnie (przeniósł lub wykonał akcję).
                    } else {
                        // console.log("Clicked element is close button or toggle, handled by other listeners."); // Opcjonalny log
                    }
                } else {
                    // console.log("Clicked inside mobile menu, but not on a link."); // Opcjonalny log
                }
            }
        });
    } // Koniec listenera dla mainMenu

    // ZMODYFIKOWANY LISTENER DLA KLIKNIĘĆ NA DOKUMENCIE
    console.log("Adding document click listener..."); // LOG 4: Sprawdzenie dodawania listenera do document
    document.addEventListener('click', function (e) {
        console.log("Document clicked!"); // LOG 5: Potwierdzenie kliknięcia w document

        const target = e.target;
        // Ponowne sprawdzenie isMobileView, bo stan mógł się zmienić od załadowania strony
        const isMobileView = hamburgerButton && window.getComputedStyle(hamburgerButton).display === 'block';
        console.log("isMobileView check inside document click:", isMobileView); // LOG 6: Sprawdzenie isMobileView w document click

        // Zamykanie menu mobilnego, jeśli kliknięto poza nim i poza hamburgerem
        if (mainMenu && mainMenu.classList.contains('is-active')) {
            // console.log("Checking if click was outside mobile menu..."); // Opcjonalny log
            // Sprawdź, czy kliknięty cel NIE znajduje się wewnątrz otwartego menu
            // ORAZ czy kliknięty cel NIE jest samym hamburgerem
            if (!mainMenu.contains(target) && !hamburgerButton.contains(target)) {
                console.log("Click detected outside active mobile menu and hamburger. Closing menu.");
                toggleMobileMenu();
            } else {
                // console.log("Click was inside mobile menu or on hamburger button."); // Opcjonalny log
            }
        }

        // Zamykanie submenu desktopowego, jeśli kliknięto poza przełącznikiem
        if (!isMobileView) {
            // console.log("Checking if click was outside dropdown toggle in desktop view..."); // Opcjonalny log
            // Sprawdź, czy kliknięty element (lub jego rodzic) jest przełącznikiem dropdown
            const clickedOnToggle = target.closest('.dropdown-toggle');
            if (!clickedOnToggle) {
                // console.log("Click was outside any dropdown toggle. Closing all submenus."); // Opcjonalny log
                closeAllSubmenus(); // Zamknij wszystkie submenus, jeśli kliknięto poza nimi
            } else {
                // console.log("Click was on a dropdown toggle, handled by its own listener."); // Opcjonalny log
            }
        }
    }); // Koniec listenera dla document


    // Zamykanie menu mobilnego klawiszem Escape
    console.log("Adding keydown listener for Escape key");
    document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && mainMenu && mainMenu.classList.contains('is-active')) {
            console.log("Escape key pressed, closing mobile menu..."); // LOG: Zamykanie Esc
            toggleMobileMenu();
        }
    });

    console.log("Menu script initialization finished."); // LOG 7: Koniec inicjalizacji

}); // Koniec DOMContentLoaded